import { MfeReactComponent } from '@carvana/microfrontend-react';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Blocker } from 'react-router-dom';
import { Step } from '|/app/services';
import Loading from '|/components/base/loading';
import { DevicePlatformContext, PageEventContext, useNavigationBlockContext } from '|/context';
import PurchaseContext from '|/context/purchase-context';
import { loadVerifxMfe } from '|/hooks/use-global-mfe-config';
import useNavigateAwayFromPurchase from '|/hooks/use-navigate-away-from-purchase';
import useNavigateInPurchase from '|/hooks/use-navigate-in-purchase';
import useNavigateToNextStep from '|/hooks/use-navigate-to-next-step';

const UNBLOCKED_BLOCKER: Blocker = {
  state: 'unblocked',
  proceed: undefined,
  reset: undefined,
  location: undefined
};

const VerifxMfeRoute: React.FC<{ step: Step | null }> = ({ step }) => {
  const { vehicleId } = useContext(PurchaseContext);
  const devicePlatform = useContext(DevicePlatformContext);
  const pageEventContext = useContext(PageEventContext);
  const navigateToNextStep = useNavigateToNextStep();
  const navigateInPurchase = useNavigateInPurchase();
  const navigateAwayFromPurchase = useNavigateAwayFromPurchase();
  const { addBlocker, removeBlocker } = useNavigationBlockContext();

  const [mfeBlocker, setMfeBlocker] = useState<Blocker>(UNBLOCKED_BLOCKER);

  const setShouldBlock = useCallback(
    (shouldBlock: boolean) => {
      if (shouldBlock) {
        addBlocker(
          'mfe',
          () => true,
          blocker => setMfeBlocker(blocker)
        );
      } else {
        removeBlocker('mfe');
        setMfeBlocker(UNBLOCKED_BLOCKER);
      }
    },
    [addBlocker, removeBlocker]
  );

  useEffect(() => {
    loadVerifxMfe();
  }, []);

  useEffect(() => () => removeBlocker('mfe'), [removeBlocker]);

  return (
    <MfeReactComponent
      module="PurchaseVerificationsModule"
      component="default"
      step={step}
      vehicleId={vehicleId}
      devicePlatform={devicePlatform}
      pageEventContext={pageEventContext}
      onNavigateToNextStep={navigateToNextStep}
      onNavigateInPurchase={navigateInPurchase}
      onNavigateAwayFromPurchase={navigateAwayFromPurchase}
      blocker={mfeBlocker}
      loading={<Loading />}
      setShouldBlock={setShouldBlock}
      onComponentError={({ id, error }: { id: string; error?: Error }) => {
        throw new Error(`Verifx MFE component failed: ${id}`, { cause: error });
      }}
    />
  );
};

export default VerifxMfeRoute;
